module.exports = __webpack_public_path__ + "static/media/greyCheck.f59a0dcd.svg";